import React, { useEffect } from 'react';
import { Button, Input, Form, Empty, Avatar, Spin } from 'antd';
import { JSXMap, errorCatch, useAuth, GETWITH, Action, QueryDetail, POST, useTranslateContext, QueryParam, Model, ycStorage } from 'fennec-ui';

import Icofont from 'react-icofont';
import { FileSearchOutlined, UserOutlined } from '@ant-design/icons';
import { ycBucket } from '../../../common/Tool';
import Dancer from '../Dancer';

var _ = require('lodash');

function SearchUser(props) {
    const auth = useAuth();
    const { value, onChange, gender } = props;

    useEffect(() => {
        if (_.isObject(value) ? value : undefined) {
            setCurrentUser(value)
        }
    }, [value])
    //---
    const [currentUser, setCurrentUser] = React.useState();
    useEffect(() => {
        onChange(currentUser)
    }, [currentUser])

    const [loading, setLoading] = React.useState(false);
    const [users, setUsers] = React.useState([]);
    const requestUsers = (q) => {
        if (q) {
            setLoading(true);
            let filters = [
                QueryDetail("model"),
                QueryParam("count", "8"),
                QueryParam("q", q)
            ];
            if (gender) {
                filters.push(QueryParam("w-gender.ID", gender));
            }
            GETWITH(auth, `/api/u/search`, filters, ({ data }) => {
                setUsers(data);
                setLoading(false);
            }, (err) => errorCatch(err, () => setLoading(false)));
        } else {
            setUsers([])
        }
    };
    const _onSearch = (v) => requestUsers(v);
    const onSearch = React.useCallback(_.throttle(_onSearch, 1000, { trailing: true }), []);
    //---

    const triggerFunc = React.useMemo(() => (click) => (<Button
        onClick={click}
        size='small'
        icon={<FileSearchOutlined />}
    />), [currentUser]);

    const actionFunc = React.useMemo(() => (values, unlock, close) => {
        setCurrentUser(values?.search);
        close();
    }, [setCurrentUser])

    const finduserAction = React.useCallback((values, unlock, close) => {
        POST(auth, "/api/find/finduserfilter", { ...values },
            ({ data }) => {
                close(data);
            },
            (err) => errorCatch(err, unlock));
    }, [auth])

    const steps = React.useMemo(() => [
        {
            key: "search",
            name: "Шаг 1",
            action: finduserAction,
            form: Model,
            meta: [
                {
                    label: "Email",
                    name: "Email",
                    type: "string",
                    display: (v) => v,
                    validators: {
                        required: true,
                        min: null,
                        max: null,
                        pattern: null
                    },
                },
                {
                    label: "Фамилия",
                    name: "Lastname",
                    type: "string",
                    display: (v) => v,
                    validators: {
                        required: true,
                        min: null,
                        max: null,
                        pattern: null
                    },
                },
                {
                    label: "Имя",
                    name: "Firstname",
                    type: "string",
                    display: (v) => v,
                    validators: {
                        required: true,
                        min: null,
                        max: null,
                        pattern: null
                    },
                },
            ],
        },
        {
            key: "select",
            name: "Шаг 2",
            noAntForm: true,
            form: (props) => {
                return (
                    <div style={{ padding: "0px 10px" }}>
                        <div>Подтвердите выбор пользователя:</div>
                        <div>ФИО: <span style={{ color: "#000" }}>{(props.data) ? props.data.search.firstname + " " + props.data.search.lastname : ""}</span></div>
                        <div>Email: <span style={{ color: "#000" }}>{(props.data) ? props.data.search.email : ""}</span></div>
                    </div>
                )
            },
        }
    ], [auth, finduserAction])

    function maskPhone(a) {
        let phone = a?.replace(/^\+/, "")
        phone = phone?.replace(/^7/, "")
        return phone.substr(0, 3) + "*****" + phone.substr(-3)

        // const cleaned = a.replace(/\D/g, ''); // Удаляем все нецифровые символы
        // if (cleaned.length < 6) return phone; // Возвращаем исходное значение, если цифр недостаточно

        // const firstThree = cleaned.substring(0, 3);
        // const lastThree = cleaned.substring(cleaned.length - 3);
        // const stars = '*'.repeat(Math.max(0, cleaned.length - 6)); // Заменяем средние цифры

        // return firstThree + stars + lastThree;
    }
    function maskEmail(email) {
        const parts = email.split('@');
        if (parts.length !== 2) return email; // Если нет "@" или их несколько

        const [localPart, domain] = parts;
        if (localPart.length <= 1) return email; // Не маскируем короткие локальные части

        // Оставляем первый и последний символ локальной части, заменяя остальное на *
        const maskedLocal =
            localPart[0] +
            '*'.repeat(Math.max(0, localPart.length - 2)) +
            localPart.slice(-1);

        return maskedLocal + '@' + domain;
    }

    return (
        <div style={{
            borderRadius: "4px", backgroundColor: "white"
        }}>
            <div style={{ display: "flex", textAlign: "left", gap: "5px", lineHeight: "16px", padding: "0 0 15px 0" }}>
                <div>
                    <Avatar style={{
                        width: "65px",
                        height: "65px",
                        background: (currentUser?.genderID === 1) ? "rgb(0 123 255 / 25%)" : (currentUser?.genderID === 2) ? "rgb(255 0 0 / 25%)" : "rgba(216, 216, 216, 0.2)"
                    }} src={(currentUser?.avatarMin) ? ycStorage(auth) + ycBucket(auth) + "/" + currentUser?.avatarMin : undefined} size="large" shape='square' icon={<UserOutlined style={{ padding: 0 }} />} />
                </div>
                <div className='' style={{ flex: "auto" }}>
                    {!currentUser && <div style={{ color: "rgba(0,0,0,0.8)" }}>
                        <div style={{ fontSize: "16px" }}>Пользователь не выбран</div>
                        <div style={{ fontSize: "12px", fontStyle: "italic" }}>Воспользуйтесь быстрым поиском ниже или выберите поиском по параметрам, нажав кнопку справа</div>
                    </div>}
                    {(currentUser?.lastname || currentUser?.firstname) && <div style={{
                        color: "#1890ff",
                        textDecoration: "none",
                        backgroundColor: "transparent",
                        outline: "none",
                        cursor: "pointer",
                        transition: "color 0.3s"
                    }}>
                        {currentUser?.lastname + " " + currentUser?.firstname}
                    </div>}
                    {currentUser?.aliase && <div style={{ color: "rgba(0,0,0,0.8)", fontSize: "12px" }}>{currentUser?.aliase}</div>}
                    {currentUser?.phone && <div style={{ display: "flex", gap: "3px", alignItems: "center", fontSize: "12px" }}>
                        <div><i className="fa fa-phone"></i></div>
                        <div>
                            <div style={{ overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>
                                {maskPhone(currentUser?.phone)}
                            </div>
                        </div>
                    </div>}
                    {currentUser?.city && <div style={{ color: "rgba(0,0,0,0.8)", fontSize: "12px" }}>г.{(_.isObject(currentUser?.city)) ? currentUser?.city?.name : currentUser?.city}</div>}
                </div>
                <div>
                    <Action
                        auth={auth}
                        mode="func"
                        trigger={triggerFunc}
                        action={actionFunc}
                        steps={steps}
                        title={"Выбор ассистента"}
                        modal={{
                            minWidth: "250px",
                            title: "Выбрать ассистента",
                        }}
                    />
                </div>
            </div>
            <div>
                <Input allowClear onChange={(e) => onSearch(e.target.value)} style={{ borderRadius: "4px" }} prefix={<Icofont icon="search" style={{ fontSize: "12px" }} />} />
                <Spin spinning={loading}>
                    <div style={{ padding: "9px 2px 0px 2px", display: "flex", flexWrap: "wrap", gap: "5px", alignContent: "flex-start" }}>
                        {(users && users.length <= 0) && <div style={{ width: "100%" }}><Empty imageStyle={{ height: "30px" }} description={<span style={{ fontSize: "12px" }}>Нет данных</span>} image={Empty.PRESENTED_IMAGE_SIMPLE} /></div>}
                        {JSXMap(users, (item, idx) => (
                            <div key={item.ID} className={`user-selector${(item.ID !== undefined && item.ID === currentUser?.ID) ? " selected" : ""}`} onClick={() => setCurrentUser(item)}>
                                <div style={{ display: "flex", textAlign: "left", gap: "5px", lineHeight: "16px" }}>
                                    <Avatar style={{ background: (item?.genderID === 1) ? "rgb(0 123 255 / 25%)" : "rgb(255 0 0 / 25%)" }} src={(item?.avatarMin) ? ycStorage(auth) + ycBucket(auth) + "/" + item?.avatarMin : undefined} size="large" shape='square' icon={<UserOutlined style={{ padding: 0 }} />} />
                                    <div className='' style={{ flex: "auto" }}>
                                        <div style={{
                                            color: "#1890ff",
                                            textDecoration: "none",
                                            backgroundColor: "transparent",
                                            outline: "none",
                                            cursor: "pointer",
                                            transition: "color 0.3s"
                                        }}>
                                            {item?.lastname + " " + item?.firstname}
                                        </div>
                                        {item?.aliase && <div style={{ color: "rgba(0,0,0,0.8)", fontSize: "12px" }}>{item?.aliase}</div>}
                                        {item.phone && <div style={{ display: "flex", gap: "3px", alignItems: "center", fontSize: "12px" }}>
                                            <div><i className="fa fa-phone"></i></div>
                                            <div><div style={{ overflow: "hidden", whiteSpace: "nowrap", textOverflow: "ellipsis" }}>{item.phone}</div></div>
                                        </div>}
                                        {item?.city && <div style={{ color: "rgba(0,0,0,0.8)", fontSize: "12px" }}>г.{(_.isObject(item?.city)) ? item?.city?.name : item?.city}</div>}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </Spin>
            </div>
        </div>
    )
}
export default function ModernUserSelection(props) {
    const t = useTranslateContext();
    const { auth, form, submit, object, genderID } = props;
    useEffect(() => {
        form.resetFields();
    }, []);


    return (
        <div>
            {object && <div style={{ paddingBottom: "10px" }}>
                <Dancer key={object?.ID} item={object} />
                {/* {(object?.user.genderID === 1) ? <MaleDancer name={object?.user.lastname + " " + object?.user.firstname} /> : <FemaleDancer name={object?.user.lastname + " " + object?.user.firstname} />} */}
            </div>}
            <Form
                form={form}
                onFinish={submit}
                labelAlign={"left"}
                layout={"vertical"}
                initialValues={object}
            >
                <Form.Item label={t("Пользователь")}
                    name="polzovatel"
                    rules={[{ required: true, message: t('Пожалуйста, укажите пользователя!') }]}
                >
                    <SearchUser gender={genderID} />
                </Form.Item>
            </Form>
        </div>
    );
};